module.exports = __webpack_public_path__ + "img/defaultHeadImg.b49473a7.png";